import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function Cancel() {
  return (
    <div
      data-testid="cancel-page"
      className="min-h-screen bg-ink flex items-center justify-center px-6 grain"
    >
      <div className="max-w-xl w-full border border-white/10 bg-[#0F0F0F] p-12 text-center">
        <XCircle className="text-gold mx-auto mb-6" size={36} strokeWidth={1.5} />
        <div className="data-label mb-4">/ Checkout Cancelled</div>
        <h1 className="font-display text-4xl sm:text-5xl leading-tight text-white mb-4">
          No worries — nothing was charged.
        </h1>
        <p className="text-white/70 mb-10">
          Whenever you're ready, come back and pick a plan. We'll be here.
        </p>
        <Link
          to="/#pricing"
          data-testid="cancel-back-pricing"
          className="inline-flex items-center gap-2 bg-gold text-ink px-6 py-3 text-[11px] tracking-[0.3em] uppercase font-semibold hover:bg-gold-dark transition-colors"
        >
          Back to Plans →
        </Link>
      </div>
    </div>
  );
}
